import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/error_dialog_head.png'


const _hoisted_1 = { class: "error-submit-wrapper" }
const _hoisted_2 = { class: "error-bg" }
const _hoisted_3 = { class: "error-content" }
const _hoisted_4 = { class: "error-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["data-text"]
const _hoisted_7 = { class: "flex-row flex-wrap mb-3 mt-3" }
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "error-btn-group" }

import { openMsgToast } from "@/views/AIGenerate/openModal"
import { IonButton, modalController } from "@ionic/vue"
import {
  computed,
  getCurrentInstance,
  onMounted,
  ref,
} from "vue"
import myAjax from "@/js/http"
import http from "@/js/http"
import AttachmentImage from "@/views/personal/AttachmentImage.vue"
import { useStorage } from "@vueuse/core"
import mqttServer from "@/js/mqtt"

interface FileObjType {
  atmId: number | string
  fileUrl: any
}

interface CommonType {
  label: string
  value: number
}

interface WordObjType {
  vocabularyId?: number
  courseId?: number
  word?: string
  paraphrase?: string
  suggestionType?: number
  description?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorSubmitDialog',
  props: {
    wordObj: { default: () => ({}) }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props
const userInfo = useStorage("userinfo", {})

const instance = getCurrentInstance() as any
const wordObj = computed(() => props.wordObj)
const errorMap: CommonType[] = [
  {
    label: "发音不标准",
    value: 1,
  },
  {
    label: "释义错误",
    value: 2,
  },
  {
    label: "没有发音",
    value: 3,
  },
  {
    label: "拼写错误",
    value: 4,
  },
]
const active = ref<number[]>([])
const remark = ref("")
const fileList = ref<FileObjType[]>([])
const fileValue = ref<any>()

const publish = ref<any>({
  topic: "10/browser",
  qos: 0,
  payload: '{ "msg": "Hello, I am browser." }',
})

const instructData = ref<any>({
  project: "lxll",
  page: "teachIndex",
  module: "ErrorSubmitDialog",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
})

onMounted(() => {
  mqttServer.onMqttMessage(instructData.value.module, onMessageReceived)
})
__expose({
  changeActive,
  handleRemark,
  openMsgToast,
  confirm,
  cancelSync,
})

function handleRemark(str: any) {
  remark.value = str
}

function remarkChange(e: any, synchronous: any) {
  console.log(e)
  if (synchronous == undefined) {
    // mqttServer.pushMsg(instructData.value, { fn: 'onFiveClose', msgType: 'function' })
    mqttServer.pushMsg(instructData.value, {
      params: e.target.value,
      fn: "handleRemark",
      msgType: "function",
    })
  }
}

async function onMessageReceived(msg: any) {
  console.log(msg)
  if (Array.isArray(msg.params)) {
    instance?.exposed[msg.fn](...msg.params)
  } else {
    instance?.exposed[msg.fn](msg.params)
    // this[msg.fn](msg.params)
  }
}

function instructMeth(instruct: any, msg: any, params: any, fn: any) {
  const obj = {
    ...instructData.value,
  }
  obj.data = instruct
  obj.params = params
  obj.msg = msg
  obj.fn = fn
  obj.type = userInfo.value.userType
  publish.value.payload = JSON.stringify(obj)
}

function changeActive(activeValue: number, synchronous: any) {
  if (synchronous == undefined) {
    mqttServer.pushMsg(instructData.value, {
      params: [activeValue, undefined],
      fn: "changeActive",
      msgType: "function",
    })

    // instructMeth('', '', [activeValue], 'changeActive')
    // doPublish(publish.value)
  }

  if (active.value.includes(activeValue)) {
    active.value = active.value.filter((i) => i !== activeValue)
  } else {
    active.value.push(activeValue)
  }
}

function handleAtmIds() {
  const arr = []
  for (let i of fileList.value) {
    arr.push(i.atmId)
  }
  return arr.join(",")
}

async function confirm(synchronous: any) {
  if (remark.value.length > 100) {
    if (synchronous == undefined) {
      mqttServer.pushMsg(instructData.value, {
        params: "超出文字100的长度限制，请重新输入",
        fn: "openMsgToast",
        msgType: "function",
      })
    }

    return openMsgToast("超出文字100的长度限制，请重新输入")
  }
  if (active.value.length > 0) {
    const res = await myAjax.post("/suggestion/saveSuggestion", {
      vocabularyId: wordObj.value.vocabularyId,
      courseId: instance.appContext.config.globalProperties.store.getAppointment().courseId,
      word: wordObj.value.word,
      paraphrase: wordObj.value.paraphrase,
      description: remark.value,
      suggestionType: active.value.join(";"),
      atmIds: handleAtmIds(),
    })

    if (res.data.code === 200) {
      mqttServer
        .pushMsg(instructData.value, {
          params: "提交成功，谢谢您的反馈！",
          fn: "openMsgToast",
          msgType: "function",
        })
        .then(() => {
          openMsgToast("提交成功，谢谢您的反馈！")
          mqttServer
            .pushMsg(instructData.value, {
              params: "",
              fn: "cancelSync",
              msgType: "function",
            })
            .then(() => {
              modalController.dismiss("cancel")
            })
        })

      // instructMeth('', '', i18n.global.t('提交成功，谢谢您的反馈！'), 'openMsgToast')
      // doPublish(publish.value)
      // await modalController.dismiss("cancel")
    } else {
      openMsgToast(res.data.message)
    }
  } else {
    mqttServer.pushMsg(instructData.value, {
      params: "请选择你要反馈的问题",
      fn: "openMsgToast",
      msgType: "function",
    })

    // instructMeth('', '', i18n.global.t('请选择你要反馈的问题'), 'openMsgToast')
    // doPublish(publish.value)
    openMsgToast("请选择你要反馈的问题")
  }
}

async function cancel() {
  mqttServer
    .pushMsg(instructData.value, {
      params: "",
      fn: "cancelSync",
      msgType: "function",
    })
    .then(() => {
      modalController.dismiss("cancel")
    })
}

function cancelSync() {
  modalController.dismiss("cancel")
}

async function openImage(imageUrl: string) {
  const modal = await modalController.create({
    component: AttachmentImage,
    componentProps: { imageUrl: imageUrl },
    cssClass: "modal_controller_class",
  })
  return modal.present()
}

function handleFileInputChange(e: any) {
  if (fileList.value.length >= 3) {
    openMsgToast("最多上传3张图片")
    return
  }

  const file = e.target.files[0]

  if (!file) {
    return
  }

  if (!/image\/+/g.test(file.type)) {
    // 其他格式文件
    openMsgToast("请上传图片文件!")
    return
  }
  if (file) {
    uploadFileToOss(file)
  }
}

// function uploadFormData(label: string, compressionFile: any) {
//   const form = new FormData();
//   const dataTimestamp = new Date().getTime() * 10 ** 4 * Math.random();
//   form.append("label", label);
//   form.append("dataTimestamp", dataTimestamp + "");
//   form.append("file", compressionFile);
//   form.append("fileType", "1");
//
//   myAjax.post("/attachment/uploadAttachment", form).then((res) => {
//     if (res.data.success) {
//       const fileUrl = URL.createObjectURL(compressionFile);
//       fileList.value.push({ atmId: res.data.data.atmId, fileUrl: fileUrl });
//       fileValue.value = ""; // 清空上传文件value值，为了避免第二次上传同样文件无法出发change事件
//     } else {
//       openMsgToast(res.data.error);
//     }
//   });
// }

async function uploadFileToOss(file: any) {
  if (file) {
    const formData = new FormData()
    formData.append("file", file)
    const res = await http.post("/attachment/uploadImageOss", formData, undefined, undefined, {
      ossFileUrl: "edu_suggestion_v3",
      label: "EDU_SUGGESTION",
    })
    if (res.data.code === 200) {
      const fileUrl = URL.createObjectURL(file)
      fileList.value.push({ atmId: res.data.data, fileUrl: fileUrl })
      fileValue.value = "" // 清空上传文件value值，为了避免第二次上传同样文件无法出发change事件
      return res.data.data
    } else {
      await openMsgToast(res.data.error ?? "上传oss错误")
      return undefined
    }
  } else {
    return undefined
  }
}

function deleteCurrentImage(atmId: number | string) {
  fileList.value = fileList.value.filter((i) => i.atmId !== atmId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("img", {
        class: "error-bg-img",
        src: _imports_0,
        alt: ""
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "error-title" }, "选择你要反馈的问题", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(errorMap, (item) => {
            return _createElementVNode("span", {
              key: item.value,
              class: _normalizeClass(['error-list-item', active.value.includes(item.value) && 'error-list-item-active']),
              onClick: ($event: any) => (changeActive(item.value))
            }, _toDisplayString(item.label), 11, _hoisted_5)
          }), 64))
        ]),
        _createElementVNode("div", {
          class: "error-text",
          "data-text": remark.value.length + '/100'
        }, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((remark).value = $event)),
            class: "error-textarea",
            maxlength: "100",
            placeholder: "请输入备注"
          }, null, 512), [
            [_vModelText, remark.value]
          ])
        ], 8, _hoisted_6),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "error-title" }, "添加图片", -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (i, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "file-list"
            }, [
              _createElementVNode("img", {
                class: "file-list-img",
                src: i.fileUrl,
                onClick: ($event: any) => (openImage(i.fileUrl))
              }, null, 8, _hoisted_8),
              _createElementVNode("i", {
                class: "file-delete",
                onClick: ($event: any) => (deleteCurrentImage(i.atmId))
              }, null, 8, _hoisted_9)
            ]))
          }), 128)),
          _createElementVNode("input", {
            id: "file-input",
            value: fileValue.value,
            class: "file-input",
            type: "file",
            accept: ".jpg,.jpeg,.png,.webp,.svg,.bmp",
            onChange: handleFileInputChange
          }, null, 40, _hoisted_10),
          _cache[1] || (_cache[1] = _createElementVNode("label", {
            for: "file-input",
            class: "file-input-label"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(IonButton), {
            class: "error-btn error-btn__cancel",
            onClick: cancel
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("取消")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(_unref(IonButton), {
            class: "error-btn error-btn__confirm",
            onClick: confirm
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("提交")
            ])),
            _: 1,
            __: [3]
          })
        ])
      ])
    ])
  ]))
}
}

})